import keyBy from "lodash.keyby"

import schemasMap from "./schemas"
import operations from "./operations.json"

const TYPE_OBJECT = "object"


const extendSchema = (schema, inputs) => {
  const inputKeys = inputs.map(input => input.name)
  const schemaKeys = schema.map(input => input.name)

  const extraKeys = schemaKeys.filter(key => !inputKeys.includes(key))
  const formKeys = [...inputKeys, ...extraKeys]

  const schemaMap = keyBy(schema, 'name')
  const inputsMap = keyBy(inputs, 'name')

  const extendedSchema = formKeys.map(key => {
    const customInput = inputsMap[key]
    const defaultInput = schemaMap[key]

    if (!defaultInput) {
      return { ...customInput }
    }

    const { type } = defaultInput
    const isObject = type === TYPE_OBJECT

    if (isObject && customInput) {
      const { schema: defaultSchema } = defaultInput
      const { schema: inputSchema = [] } = customInput

      customInput.schema = extendSchema(defaultSchema, inputSchema)
    }

    return {
      ...defaultInput,
      ...customInput
    }
  })

  return extendedSchema
}


const get = (operationId) => {
  const isSupported = operations.includes(operationId)

  if (!isSupported) {
    const hint = `Add "${operationId}" to "src/api/operations/index.js" and run "npm run update".`
    const message = `Operation "${operationId}" is missing.`

    // eslint-disable-next-line no-console
    console.info(hint)

    throw new Error(message)
  }

  const schemaId = operationId.replace('/', '_').toUpperCase()
  const schema = schemasMap[schemaId]

  if (!schema) {
    return { id: operationId }
  }

  const getSchema = inputs => extendSchema(schema, inputs)

  return { id: operationId, schema, getSchema }
}


export default {
  get
}
